import Repository from './Repository';

const resource = '/default';

export default class ProductRepository {
  static login(username, password) {
    return Repository.post(`${resource}/login`, { username, password });
  }

  static isGuest() {
    return Repository.post(`${resource}/is-guest`);
  }

  static checkUsername(username) {
    return Repository.post(`${resource}/check-username`, { username });
  }
}
